// 에디터 계정 입력 상한(글자 수).
// 플랫폼 백엔드는 등록(POST /auth/editor/register)과 정보 수정(PUT /roles/editors/{editor_idx}) 모두
// 이 길이를 넘으면 400 "이름은 30자 이내로 입력해주세요." 처럼 항목 이름을 넣은 문장을 돌려줍니다
// (docs/회원관리_API.md §2.3). 화면은 maxlength 로 먼저 막고, 400 이면 그 detail 을 그대로 띄웁니다.
export const EDITOR_INPUT_MAX = {
  name: 30,
  email: 50,
  phone: 20,
  memo: 200,
};
